const NewsletterSubscription = () => {
    return (
      <>
        {/* Newsletter Subscription Section - Now after Services */}
        <div className="bg-gray-50 py-16 sm:py-24">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="lg:grid lg:grid-cols-2 lg:gap-8 lg:items-center">
              <div className="mb-8 lg:mb-0">
                <h2 className="text-3xl font-extrabold text-gray-900 sm:text-4xl">
                  Get Marketing Insights Delivered to Your Inbox
                </h2>
                <p className="mt-3 max-w-3xl text-lg text-gray-600">
                  Join our newsletter and receive actionable marketing tips, 
                  industry trends, and exclusive case studies to help grow your business.
                </p>
                <div className="mt-8">
                  <form className="sm:max-w-md">
                    <div className="flex flex-col sm:flex-row gap-3">
                      <input
                        type="email"
                        name="email"
                        id="email"
                        className="w-full px-5 py-3 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:ring-primary focus:border-primary"
                        placeholder="Enter your email"
                        required
                      />
                      <button
                        type="submit"
                        className="px-6 py-3 border border-transparent text-base font-medium rounded-md text-white bg-primary hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary"
                      >
                        Subscribe
                      </button>
                    </div>
                    <p className="mt-3 text-sm text-gray-500">
                      We respect your privacy. Unsubscribe at any time.
                    </p>
                  </form>
                </div>
              </div>
              <div>
                <div className="bg-white rounded-lg shadow-md p-8">
                  <h3 className="text-lg font-medium text-gray-900 mb-4">You'll receive:</h3>
                  <ul className="space-y-4">
                    <li className="flex">
                      <svg className="flex-shrink-0 h-6 w-6 text-primary" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                      </svg>
                      <span className="ml-3 text-gray-600">Weekly digital marketing tips</span>
                    </li>
                    <li className="flex">
                      <svg className="flex-shrink-0 h-6 w-6 text-primary" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                      </svg>
                      <span className="ml-3 text-gray-600">Exclusive case studies & benchmarks</span>
                    </li>
                    <li className="flex">
                      <svg className="flex-shrink-0 h-6 w-6 text-primary" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                      </svg>
                      <span className="ml-3 text-gray-600">First access to new tools & services</span>
                    </li>
                    <li className="flex">
                      <svg className="flex-shrink-0 h-6 w-6 text-primary" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                      </svg>
                      <span className="ml-3 text-gray-600">Special subscriber-only offers</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    )
}

export default NewsletterSubscription